
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28.87 28.87"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"Paypal_wallet_svg__a","x1":"-3.04","x2":"29.49","y1":"-2.41","y2":"28.95","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#253b80"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#179bd7"}})])]),_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"Layer 1"}},[_c('rect',{attrs:{"width":"28.87","height":"28.87","fill":"url(#Paypal_wallet_svg__a)","rx":"6.48","ry":"6.48"}}),_c('path',{attrs:{"fill":"#fff","d":"M19.88 10.5l-.05.29c-.66 3.37-2.9 4.53-5.77 4.53H12.6a.71.71 0 00-.7.6l-.75 4.74-.21 1.34a.37.37 0 00.37.43h2.59a.62.62 0 00.62-.52v-.13l.48-3.09v-.17a.62.62 0 01.62-.53h.39c2.51 0 4.47-1 5-4a3.38 3.38 0 00-.52-3 2.47 2.47 0 00-.61-.49z","data-name":"<Path>","opacity":".3"}}),_c('path',{attrs:{"fill":"#fff","d":"M19.19 10.23l-.31-.08-.33-.06a8.1 8.1 0 00-1.28-.09h-3.9a.62.62 0 00-.61.53l-.83 5.25v.15a.71.71 0 01.7-.6h1.46c2.87 0 5.11-1.16 5.77-4.53 0-.1 0-.2.05-.29a3.49 3.49 0 00-.54-.23z","data-name":"<Path>","opacity":".5"}}),_c('path',{attrs:{"fill":"#fff","d":"M12.75 10.52a.62.62 0 01.61-.53h3.9a8.1 8.1 0 011.29.09l.33.06.31.08h.15a3.54 3.54 0 01.54.23 3.18 3.18 0 00-.67-2.86c-.74-.84-2.08-1.21-3.79-1.21h-5a.71.71 0 00-.7.6L7.66 20.17a.43.43 0 00.42.49h3.07l.77-4.89z","data-name":"<Path>"}})])])])
          )
        }
      }
    